import { getStore } from '../store/Store';

export default function getSelectedFolderId(): string {
    return getStore().folders.selectedFolderId;
}
